import api from "app/api";
import { Options } from "common";
import { ProgramItem } from "features/programs/programApi";
import { ReviewPartnerItem } from "features/review-partners/reviewPartnerApi";

export interface ProgramReviewUrlItem {
  id: number;
  review_partner_id: number;
  review_partner?: ReviewPartnerItem;
  program_id: number;
  program?: ProgramItem;
  lang: string;
  url: string;
}

export type ProgramReviewUrlOptions = Options<"role" | "status">;

export function getProgramReviewUrlService(scope?: any) {
  return api.getService<
    ProgramReviewUrlItem,
    ProgramReviewUrlItem,
    ProgramReviewUrlOptions
  >("program-review-urls", {
    scope,
    //params goes here
  });
}
